module.exports = __webpack_public_path__ + "img/vacuum_2.f83e229a.jpg";